module.exports = __webpack_public_path__ + "media/images/lb/596-db8071b7f45bb7a26e9c8c0bd1956eef.svg";